export const silentAuction = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		height: '100%',
		minHeight: 'calc(100vh - 128px)',

		'@media (max-width: 1199.98px)': {
			minHeight: 'calc(100vh - 152px)',
		},
	},
};
